import styled, { css } from "styled-components";
import AntModal from "antd/es/modal";
import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { selectIsDarkMode } from "@shared/slices/common.slice";
import { buttonStyles } from "common/Buttons/Button";
import { hexToRGB } from "@shared/utils/misc";

export const modalStyles = css`
  .ant-modal-mask {
    background: ${(p) => hexToRGB(p.theme.colors.black, 0.6)};
  }
  .ant-modal-content,
  .ant-modal-header {
    background: ${(p) => p.theme.colors.cardBgColor};
  }
  .ant-modal-title {
    color: ${(p) => p.theme.colors.titleColor};
  }
  .ant-modal-close-icon {
    color: ${(p) => p.theme.colors.textColor};
  }
  .ant-modal {
    .ant-btn {
      ${buttonStyles.antBtn};
    }
    .ant-btn-primary {
      ${buttonStyles.antBtnPrimary};
    }
    .ant-btn-dangerous {
      ${buttonStyles.antBtnDangerous};
    }
    .ant-btn[disabled] {
      ${buttonStyles.antBtnDisabled};
    }
    .ant-modal-confirm-content,
    .ant-modal-confirm-title {
      color: ${(p) => p.theme.colors.primaryText};
    }
  }
  .ant-modal-content {
    padding: 0;
  }
  .ant-modal-body {
    padding: 24px;
  }
  .ant-modal-header {
    margin-bottom: 0;
    padding: 16px 24px;
    border-bottom: ${(p) => p.theme.borders.lightest};
  }
  .ant-modal-footer {
    margin-top: 0;
    padding: 10px 16px;
    border-top: ${(p) => p.theme.borders.lightest};
  }
  .ant-modal-confirm.ant-modal .ant-modal-body {
    padding: 24px;
  }
`;

const Modal = styled(AntModal)`
  ${modalStyles};
  ${(p) =>
    !p.footer &&
    !p.onOk &&
    `
   .ant-modal-footer {
      display: none;
    }
  `};
`;

Modal.useModal = () => {
  const [modal, warningModalContextHolder] = AntModal.useModal();
  const isDarkMode = useSelector(selectIsDarkMode);
  const methodToReplace = [
    "info",
    "success",
    "error",
    "warning",
    "confirm",
  ] as const;
  const originalMethods = useRef<{
    [key in (typeof methodToReplace)[number]]?: (p: any) => void;
  }>({});

  useEffect(() => {
    for (let method of methodToReplace) {
      if (!(method in originalMethods.current)) {
        originalMethods.current[method] = modal[method];
      }
      // @ts-ignore
      modal[method] = (props) => {
        originalMethods.current?.[method]?.({
          ...props,
          className: isDarkMode
            ? `${props.className} dark-mode`
            : props.className,
        });
      };
    }
  }, [isDarkMode]);

  return [modal, warningModalContextHolder];
};

export default Modal;
